import { useState } from 'react';
import { useAuthContext } from './useAuthContext';
import { useCultivationCompanyContext } from './useCultivationCompanyContext'; // Import cultivation company context
import { useCompanyContext } from './useCompanyContext';

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const { dispatch } = useAuthContext();
  const { dispatch: cultivationCompanyDispatch } = useCultivationCompanyContext(); // Gebruik dispatch
  const { dispatch: companyDispatch } = useCompanyContext(); 

  console.log('API URL:', process.env.REACT_APP_API_URL);

  const login = async (email, password) => {
    setIsLoading(true);
    setError(null);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const json = await response.json();



    if (!response.ok) {
      setIsLoading(false);
      setError(json.error);
    }
    if (response.ok) {
      // Sla de user op in local storage
      localStorage.setItem('user', JSON.stringify(json));

      // Update de auth context
      dispatch({ type: 'LOGIN', payload: json });

      console.log('Dispatching cultivation company:', json.cultivation_company);
      
      // Update de cultivation company context
      cultivationCompanyDispatch({ type: 'SET_CULTIVATIONCOMPANY', payload: json.cultivation_company });

      if (json.companies && json.companies.length > 0) {
        companyDispatch({ type: 'SET_COMPANY', payload: json.companies[0] });
      }

      // Update de loading state
      setIsLoading(false);
    }
  };

  return { login, isLoading, error };
};
